import type { Ref } from "vue";

export const isCurrentEvent = (
  start: Date,
  end: Date,
  now: Ref<Date>
): boolean => {
  return now.value >= start && now.value < end;
};
